export const SHIPMENT_STATUS_STYLE: Record<string, string> = {
  READY: "bg-blue-50 text-blue-700 border-blue-200",
  BOOKED: "bg-amber-50 text-amber-700 border-amber-200",
  DELIVERED: "bg-emerald-50 text-emerald-700 border-emerald-200"
};

export const SHIPMENT_STATUS_LABEL: Record<string, string> = {
  READY: "Ready",
  BOOKED: "Booked",
  DELIVERED: "Delivered"
};

export const ANIMAL_NON_CERTIFIED_SHIPMENT_MIX_ERROR_MESSAGE =
  "Animal-non-certified pallets must ship on their own — they cannot be combined with animal or non-animal pallets in the same shipment";

export const ANIMAL_NON_CERTIFIED_SHIPMENT_VENDOR_MIX_ERROR_MESSAGE =
  "Animal-non-certified shipments must be vendor-pure — pallets from different vendors need separate shipments";
